import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import globalVar from './globalVar';
//import VCalendar from 'v-calendar';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VModal from 'vue-js-modal';

//Vue.use(VCalendar, {
//  componentPrefix: 'vc',
//});
// global variable

Vue.config.productionTip = false

Vue.use(globalVar);
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VModal)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
